module.exports = __webpack_public_path__ + "img/128.91dd7aab.jpg";